import Route from '../route.js';
import AddressForm from "./address_form.js";

$(function () {
    
    if (Route === ("account-confirm-details")) {
        const formId = "account-confirm-form";

        $("select[name='accountType']").trigger("change", { doNotHighlightInvalidFields: true });

        const CompleteRegistrationForm = new AddressForm({
            form_id: `#${formId}`,
        });
        CompleteRegistrationForm.addSubmitListener((response) => {
            if (response.success) {
                window.location.href = response.data.return_url;
            } else {
                $('#accountRegistrationFailedModal').modal('show');
                $("#accountRegistrationFailedModal").on('hidden.bs.modal', function (e) {
                    window.location.href = "/";
                });
            }
        }, () => {
            $(`#${formId} input[name='endTimestamp']`).val(Date.now());
            return true;
        });

    }
    
});
